import React, {
  Component
} from 'react';
import {
  Button,
  Container,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
  Message,
  Segment
} from 'semantic-ui-react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Link
} from 'react-router-dom';
import feathersConnect from './../../providers/feathersConnect';
import authenticationActions from './../../store/actions/authenticationActions';

class SignInView extends Component {

  constructor (props) {
    super(props);

    this.state = {
      fetching: false,
      username: '',
      password: '',
      errors: {
        username: false,
        password: false
      },
      error: null
    };
  }

  componentDidMount () {
    // check if signed in
  }

  createInputHandler = (name) => (e) => {
    this.setState({
      [name]: e.target.value
    });
  }

  signIn = (e, form) => {
    e.preventDefault();

    let {
      username,
      password
    } = this.state;

    this.setState({
      fetching: true,
      errors: {
        username: false,
        password: false
      },
      error: null
    });

    if (!username || !password) {
      this.setState({
        errors: {
          username: !!username,
          password: !!password
        }
      });

      return false;
    }

    this.props.feathers.authenticate({
      strategy: 'local',
      username: username,
      password
    })
      .then(response => {
        window.localStorage.setItem('user', JSON.stringify(response.user));
        window.localStorage.setItem('email', JSON.stringify(response.user.email));

        this.setState({
          fetching: false
        });

        this.props.authenticationSuccess(response.accessToken, response.user);
        this.props.navigate('/');
      })
      .catch(error => {
        this.setState({
          fetching: false,
          error
        });
      });
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      },
      authenticationSuccess: (token, user) => {
        dispatch(authenticationActions.auth.authenticationSuccess(token, user));
      }
    };
  }

  render () {
    let {
      fetching,
      username,
      password,
      errors,
      error
    } = this.state;

    return (
      <Container style={{ padding: 16 }}>
        <Grid doubling columns={2} centered>
          <Grid.Column>
            <Segment.Group raised color="blue">
              <Segment attached="top" textAlign="center">
                <Header as="h2">
                  INGRESO
                </Header>
              </Segment>
              <Segment loading={fetching} attached="bottom">
                <Form onSubmit={this.signIn}>
                  <Form.Input
                    required label="Username o Email" icon="user"
                    error={errors.username}
                    value={username} onChange={this.createInputHandler('username')} />
                  <Form.Input
                    required label="Clave" icon="lock" type="password"
                    error={errors.password}
                    value={password} onChange={this.createInputHandler('password')} />
                  <Link to="/forgot-password"><strong>Olvido su clave?</strong></Link>
                  <Divider/>
                  {
                    error ?
                      <Message negative>
                        <Message.Header>{error.name}</Message.Header>
                        <p>{error.message}</p>
                      </Message> : null
                  }
                  <Button type="submit" primary basic fluid><Icon name="send" />{' '}Enviar</Button>
                </Form>
              </Segment>
            </Segment.Group>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

export default feathersConnect(
  connect(
    SignInView.mapStateToProps,
    SignInView.mapDispatchToProps
  )(SignInView)
);



// WEBPACK FOOTER //
// ./client/components/pages/SignInView.js